import { Progress } from "antd";
import { useTranslation } from "react-i18next";
import i18n from "@/utils/i18n";
import dayjs from "dayjs";
import type {
  EducationDetailDto,
  EnrollmentDto,
} from "../../types/client-education-detail.types";
import {
  EducationType,
  EXCUSE_REASON_LABELS,
} from "../../types/client-education-detail.types";
import sectionStyles from "./sections.module.scss";

export function AttendanceSection(props: {
  education: EducationDetailDto;
  enrollment: EnrollmentDto;
}) {
  const { t } = useTranslation();
  const { education, enrollment } = props;
  if (
    education.type !== EducationType.ON_SITE &&
    education.type !== EducationType.ONLINE
  ) return null;

  const attendances = [...(enrollment.attendances ?? [])].sort(
    (a, b) => a.attendanceDate.localeCompare(b.attendanceDate)
  );
  const total = attendances.length;
  const present = attendances.filter((a) => a.status === 1).length;
  if (!total) return null;
  const pct = Math.round((present / total) * 100);

  return (
    <section id="attendance" className={sectionStyles.section}>
      <div className={sectionStyles.header}>
        <h2>{t("clientAttendanceSection.title")}</h2>
        <span>{present} / {total} · %{pct}</span>
      </div>
      <Progress percent={pct} showInfo={false} strokeColor="#52c41a" />
      <table style={{ width: "100%", marginTop: 12, fontSize: 14 }}>
        <thead>
          <tr style={{ textAlign: "left", color: "rgba(0,0,0,0.55)" }}>
            <th>{t("clientAttendanceSection.headerDate")}</th>
            <th>{t("clientAttendanceSection.headerStatus")}</th>
            <th>{t("clientAttendanceSection.headerExcuse")}</th>
          </tr>
        </thead>
        <tbody>
          {attendances.map((a) => (
            <tr key={a.attendanceDate}>
              <td>{dayjs(a.attendanceDate).format("DD MMM YYYY")}</td>
              <td style={{ color: a.status === 1 ? "#52c41a" : "#ff4d4f" }}>
                {a.status === 1 ? i18n.t("attendance.attended") : i18n.t("attendance.notAttended")}
              </td>
              <td style={{ color: "rgba(0,0,0,0.55)" }}>
                {a.status === 0 && a.excuseReason != null
                  ? EXCUSE_REASON_LABELS[a.excuseReason]
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
